import { render } from "./TEAM_ADDITION.vue?vue&type=template&id=28056b6a&ts=true"
import script from "./TEAM_ADDITION.vue?vue&type=script&lang=ts"
export * from "./TEAM_ADDITION.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__